"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-hoe": {
    "58971bef": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "skipSearch": false
    }],
    "alduno": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f187db73": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "skipSearch": false
    }],
    "bosco": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16f04044": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "skipSearch": false
    }],
    "ponticello": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7253b112": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "skipSearch": false
    }],
    "tremonte": [{
      "hkey": "07cff87b",
      "slug": "santa-maria-hoe",
      "name": "Santa Maria Hoè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;